import { useState } from "react";
import BoxLoader from "../../components/commons/BoxLoader/BoxLoader";
import { MyJobRatingIcon, ViewAllIcon } from "../../assets/images";
import ViewMyJobRatingDetails from "../../components/MySpace/ViewMyJobRatingDetails";
import { AverageJobRatingListDataType } from "../../redux/mySpace/mySpaceTypes";

type AppProps = {
  history: any;
  averageJobRatingFetching: boolean;
  averageJobRatingCount: number;
  averageJobRatingList: AverageJobRatingListDataType[] | [];
  averageJobRatingData: number;
  mySpaceSuccess: number | null;
};
const MyJobRating = ({
  history,
  averageJobRatingFetching,
  averageJobRatingCount,
  averageJobRatingList,
  averageJobRatingData,
  mySpaceSuccess,
}: AppProps) => {
  const [showAverageJobRatingModal, setShowAverageJobRatingModal] =
    useState(false);

  const handleToggleAvaerageJobRating = () => {
    setShowAverageJobRatingModal(!showAverageJobRatingModal);
  };
  const handleAddMangerFeedback = () => {};

  return (
    <>
      <div
        className="boxs w-100 pt-3 pb-3 pl-2 pr-2"
        style={{ height: "125px" }}
      >
        {averageJobRatingFetching ? (
          <BoxLoader style={{ height: "100%" }} />
        ) : (
          <>
            <div style={{ display: "flex", gap: "6px", marginTop: "10px" }}>
              <img
                src={MyJobRatingIcon}
                alt="PE Form Icon"
                style={{ width: "67px" }}
              />
              <div>
                <span className="boxs-container-heading">My Job Rating</span>
                <div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ fontSize: "35px", fontWeight: 500 }}>
                      {averageJobRatingData
                        ? averageJobRatingData?.toFixed(2)
                        : 0}
                    </div>

                    {
                      <div
                        className="ml-3"
                        style={{ color: "#dd4433", cursor: "pointer" }}
                        onClick={() => {
                          handleToggleAvaerageJobRating();
                        }}
                      >
                        <img src={ViewAllIcon} alt="View All Icon" />
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
            {showAverageJobRatingModal && (
              <ViewMyJobRatingDetails
                fetching={averageJobRatingFetching}
                modal={showAverageJobRatingModal}
                toggleModal={handleToggleAvaerageJobRating}
                mySpaceSuccess={mySpaceSuccess}
                averageJobRatingList={averageJobRatingList}
                averageJobRatingCount={averageJobRatingCount}
                averageJobRatingData={averageJobRatingData}
              />
            )}
          </>
        )}
      </div>
    </>
  );
};

export default MyJobRating;
